import '@fontsource-variable/inter';
import 'flag-icons/css/flag-icons.min.css';
import React from "react"
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import oidcAuth from "./services/auth/oidc-client";
import { bindOidcSessionInvalidationToStore } from "./services/auth/oidcSessionEvents";
import { loginSuccess, logout } from "./redux/authSlice";
import { bindAuthorizedSessionRefresh } from "./utils/tokenRoles";
import socketService from "./services/socketService";

// Silent renew can add or revoke roles. Replace the complete Redux auth mirror
// whenever oidc-client publishes a newly verified user instead of updating only
// the bearer token and leaving stale authorization state behind.
bindAuthorizedSessionRefresh(
    (listener) => oidcAuth.onUserLoaded(listener),
    (session) => store.dispatch(loginSuccess(session)),
    () => socketService.refreshAuthentication(),
);
bindOidcSessionInvalidationToStore(
    oidcAuth,
    store.dispatch,
    logout,
    () => socketService.disconnect(),
);

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </React.StrictMode>
);
